// interceptor request

import { encrypt, decrypt } from "../utils/crypto"; // Importa as funções de criptografia e descriptografia

export default async (request, next) => {
  // Adiciona cabeçalhos comuns
  request.headers.set("Accept", "application/json");

  // Verifica se o corpo da requisição existe
  if (request.body) {
    if (request.body instanceof FormData) {
      // Extrai arquivos e outros dados separadamente
      let files = new Map();
      let regularData = {};
      let hasFiles = false;
      
      // Separa arquivos de dados regulares
      for (let [key, value] of request.body.entries()) {
        if (value instanceof File || value instanceof Blob) {
          files.set(key, value);
          hasFiles = true;
        } else {
          regularData[key] = value;
        }
      }
      
      // Se tem arquivos, processa de maneira especial
      if (hasFiles) {
        // Cria novo FormData para o envio final
        const mixedFormData = new FormData();
        
        // Adiciona todos os arquivos sem criptografar
        for (let [key, file] of files.entries()) {
          mixedFormData.append(key, file);
        }
        
        // Criptografa os dados regulares se existirem
        if (Object.keys(regularData).length > 0) {
          const encryptedFields = encrypt(JSON.stringify(regularData));
          mixedFormData.append("encrypted_fields", `${encryptedFields}`);
        }
        
        console.log('📤 Enviando FormData com arquivos não criptografados e campos criptografados');
        request.body = mixedFormData;
      } else {
        // Para FormData sem arquivos, continua criptografando normalmente
        const encryptedData = encrypt(JSON.stringify(regularData));
        const encryptedFormData = new FormData();
        encryptedFormData.append("data", `${encryptedData}`);
        request.body = encryptedFormData;
      }
    } else if (typeof request.body === "object") {
      const encryptedData = encrypt(JSON.stringify(request.body)); // Criptografa o objeto JSON

      // request.body = JSON.stringify({ data: `ENCRYPTED:${encryptedData}` });
      request.body = JSON.stringify({ data: `${encryptedData}` });
      request.headers.set("Content-Type", "application/json");
      // request.headers.set("internal-access", "true");
    }
  }

  next(response => {
    // console.log(response)
    // Verifica se a resposta tem conteúdo
    if (response.bodyText) {
      try {
        let encryptedData = response.bodyText.trim(); // Remove espaços extras

        // Verifica se a resposta está criptografada
        
          // const encryptedPayload = encryptedData.substring(10).trim(); // Remove o prefixo
          const decryptedData = decrypt(encryptedData); // Descriptografa

          // Verifica se a resposta descriptografada é um JSON válido
          try {
            response.body = JSON.parse(decryptedData);
          } catch (jsonError) {
            response.body = decryptedData;
          }
       
      } catch (error) {
        console.error("❌ Erro ao descriptografar a resposta:", error);
      }
    } else {
      console.log("📥 Resposta está vazia ou não foi recebida");
    }

    return response;
  });
};





// import { app } from "../../config"

// // Função assíncrona para obter o IP do usuário

// // Interceptor para adicionar o IP do usuário e outros cabeçalhos em todas as solicitações
// export default async (request, next) => {
// 	try {
// 		// Obter o IP do usuário antes de continuar com a solicitação

// 		// Adicionar os cabeçalhos à solicitação
// 		request.headers.set("Accept", "application/json")
// 		request.headers.set("Content-Type", "application/json")
// 		request.headers.set("Content-Language", app.locale)

// 	} catch (error) {
// 		console.error("Erro ao configurar os cabeçalhos da solicitação:", error)
// 	}

// 	// Continuar com a solicitação
// 	next()
// }